/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CheckmarkBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={17} height={16} viewBox="0 0 17 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8.6 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM12 4.7c.2-.2.56-.273.76-.073.2.2.256.53.14.673l-4.7 5.8c-.2.2-.6.2-.8 0L4.7 8.3c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0L7.7 10z"
        />
    </AccessibleSVG>
);

export default CheckmarkBadge16;
